// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3umgN","questions":"styles_questions__2hIfH","footer":"styles_footer__2ZR4n"};